import { render, staticRenderFns } from "./Gamification.vue?vue&type=template&id=52eb4506&"
import script from "./Gamification.vue?vue&type=script&lang=ts&"
export * from "./Gamification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports